import { api } from "@/axios";
import responseHandler from "@/responseHandler.js";

const state = {
  objections: [],
  checkedObjectionExists: null,
  x: -1,
};

const getters = {
  getObjections: (state) => state.objections,
  getObjectionById: (state) => (id) => state.objections.find((x) => x.id == id),
  getCheckedObjectionExists: (state) => state.checkedObjectionExists,
};

const actions = {
  async exportObjections() {
    try {
      const resp = await api.get("/objections_export");
      if (resp.status == 200) {
        return resp.status;
      }
    } catch (error) {
      console.log("error", error);
      return error.status;
    }
  },
  async checkObjectionExists({ commit }, stu_num) {
    try {
      const resp = await api.get(`/objection_check/${stu_num}`);
      if (resp.status == 200) {
        const objection = resp.data.data.objection;
        console.log("objection", objection);
        commit("setCheckedObjectionExists", objection);
        return 200;
      } else {
        commit("setCheckedObjectionExists", null);
      }
    } catch (error) {
      //   console.log("error", error.status);
      //   console.log("error", error);
      commit("setCheckedObjectionExists", null);
      return error.status;
    }
  },
  async changeObjectionStatus({ commit }, data) {
    try {
      const resp = await api.post(`/objections/${data.id}/change_status`, {
        status: data.status,
      });

      if (resp.status == 200) {
        const objection = resp.data.data;
        commit("updateObjectionStatus", objection);
        return 200;
      }
    } catch (error) {
      return error.status;
    }
  },

  async confirmObjectionApp({ commit }, data) {
    console.log("data recived", data);
    try {
      const resp = await api.post(`/objections/${data}/confirm`);
      //console.log("resp after", resp.status);
      if (resp.status == 200) {
        const objection = resp.data.data;
        //console.log("objection after", objection);
        commit("setCheckedObjectionExists", objection);
        //return 200;
        return true;
      } else {
        //return resp.status;
        return false;
      }
    } catch (error) {
      //return error.status;
      return false;
    }
  },
  async fetchObjections({ commit }) {
    try {
      const resp = await api.get("/objections");
      if (resp.status == 200) {
        const objections = resp.data.data.objections;
        console.log("objections", objections);
        commit("setObjections", objections);
      }
    } catch (error) {
      console.log("error", error);
      return false;
    }
  },
  async updateObjection({ commit }, objection) {
    console.log("objection", objection);

    try {
      const id = objection.id;
      objection._method = "patch";

      const resp = await api.post(`/objections/${id}`, objection);
      if (resp.status == 200) {
        const objection = resp.data.data;
        console.log("objection back", objection);
        commit("updateObjection", objection);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      console.log("error", error);
      return responseHandler.respH1(error.response);
    }
  },
  async addObjection({ commit }, objection) {
    try {
      const resp = await api.post(`/objections`, objection);

      if (resp.status == 201) {
        const objection = resp.data.data;

        commit("addObjection", objection);
      }
      console.log("resp:", resp);
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async deleteObjection({ commit }, id) {
    try {
      const resp = await api.delete(`/objections/${id}`);

      if (resp.status == 204) {
        commit("deleteObjection", id);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },

  async addObjectionAttachment({ commit }, att) {
    try {
      const formData = new FormData();
      formData.append("attachment", att.attachment);

      formData.append("name", att.name);

      const resp1 = await api.post(
        `/objections/${att.objection_id}/attachments`,
        formData
      );
      console.log("resppppp___1", resp1);
      if (resp1.status == 201) {
        const att = resp1.data.data;

        commit("addObjectionAttachment", att);
      }
      console.log("resppppp___2", resp1);
      return responseHandler.respH1(resp1);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },

  async updateObjectionAttachment({ commit }, att) {
    try {
      const formData = new FormData();
      formData.append("link", att.link);
      formData.append("name", att.name);
      formData.append("_method", "patch");

      const resp = await api.post(
        `/objections_attachments/${att.id}`,
        formData
      );
      console.log("resppppp200", resp);
      if (resp.status == 200) {
        const att = resp.data.data;
        commit("updateObjectionAttachment", att);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      console.log("error", error);
      return responseHandler.respH1(error.response);
    }
  },
};

const mutations = {
  setObjections(state, objection) {
    state.objections = objection;
  },
  updateObjection(state, objection) {
    const id = objection.id;
    const index = state.objections.findIndex((objection) => objection.id == id);
    if (index !== -1) {
      state.objections[index] = objection;
    }
  },
  addObjection(state, objection) {
    state.objections.unshift(objection);
  },

  deleteObjection(state, id) {
    const index = state.objections.findIndex((p) => p.id == id);
    if (index !== -1) {
      state.objections.splice(index, 1);
    }
  },

  addObjectionAttachment(state, att) {
    const index = state.checkedObjectionExists.attachments.findIndex(
      (a) => a.id === att.id
    );
    if (index !== -1) {
      // Replace existing attachment without Vue.set
      state.checkedObjectionExists.attachments.splice(index, 1, att);
    } else {
      // Add new attachment
      state.checkedObjectionExists.attachments.push(att);
    }
  },
  updateObjectionAttachment(state, att) {
    state.x = att.id;
  },

  setCheckedObjectionExists(state, objection) {
    state.checkedObjectionExists = objection;
  },
  updateObjectionStatus(state, objection) {
    const index = state.objections.findIndex((x) => x.id == objection.id);
    if (index != -1) {
      state.objections[index].status = objection.status;
      //console.log("cfdfciv uhiuhc", objection.status);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
